import{createContext as e}from"react";/*
This file exists because both useAnalytics and AnalyticsProvider depend on it, but that can lead to circular references.
*/const t=/*#__PURE__*/e(undefined);export default t;